import { isFunction } from 'lodash-es'
import logger from '../logger'

// /////////////////////////////
// global logger debug mixin //
// /////////////////////////////

export default {
  init() {
    const lname = this.root.tagName.toLowerCase()
    if (isFunction(this.on)) {
      this.on('mount', () => logger(`COMPONENT MOUNTED :: ${lname}`, 'debug')())
      this.on('unmount', () => logger(`COMPONENT UNMOUNTED :: ${lname}`, 'debug')())
      this.on('update', () => logger(`COMPONENT UPDATE :: ${lname}`, 'debug')())
      this.on('updated', () => logger(`COMPONENT UPDATED :: ${lname}`, 'debug')())
    }
  },
}